import SUApi from './_suApi';

class SUTransferAPI extends SUApi {
  constructor() {
    super();
  }
  controllerName = 'SuTransfers';
}

export default new SUTransferAPI();
